import { PermitStep, PhotoRequirement } from "@ha/data/basic";
import { Selector } from "@ngxs/store";
import { PermitPhoto } from "../models/permit-photo.model";
import { PermitPhotoState, PermitPhotoStateModel } from "./permit-photo.state";

export class PermitPhotoSelectors {
    @Selector([PermitPhotoState])
    public static permitPhotos(state: PermitPhotoStateModel): PermitPhoto[] {
        return state?.photos;
    }

    @Selector([PermitPhotoState])
    public static permitEndPhotos(state: PermitPhotoStateModel): PermitPhoto[] {
        return state?.photos.filter((photo) => photo.step === PermitStep.ended);
    }

    @Selector([PermitPhotoState])
    public static permitPhotoRequirement(state: PermitPhotoStateModel): PhotoRequirement {
        return state?.photoRequirement;
    }

    @Selector([PermitPhotoState])
    public static getFilteredPhotosCount(step: PermitStep, questionId?: number) {
        return (state: PermitPhotoStateModel): number => {
            if (!state?.photos) {
                return 0;
            }
            if (questionId !== undefined && questionId !== null) {
                return state.photos.filter((photo) => photo.step === step && photo.questionId === questionId).length;
            }
            return state.photos.filter((photo) => photo.step === step).length;
        };
    }
}
